import React from "react";
import { Context } from "./Context";
import { UserState } from "./globalState/userState";

export const StateProvider = ({ children }) => {
  const user = UserState();
  let store = Object.assign(user);
  return <Context.Provider value={store}>{children}</Context.Provider>;
};
